import './App.css';
import HomeMain from './Pages/Home/HomeMain';
import {Routes,Router,Route} from "react-router-dom"
import Consultation from './Pages/Consultation_form/Consulted_form';
import Navbar from './Pages/Home/Navbar';
function App() {
  return (
    <div className="App">
<Navbar/>
      <Routes>
        <Route path="/" element={<HomeMain />} />
        <Route path="/Consultation" element={<Consultation />} />
      </Routes>
    </div>
  );
}

export default App;
